export const submitLogin = (email, password, fetchImpl = fetch) =>
  fetchImpl('/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password }),
  });
